














import { Component, Vue } from 'vue-property-decorator';
import AuthModule from '@/store/modules/auth.module';
import { getModule } from 'vuex-module-decorators';

@Component({})
export default class OidcCallback extends Vue {
  private authStore = getModule(AuthModule, this.$store);

  async mounted() {
    try {
      const redirectPath = await this.authStore.signInCallback();
      this.$router.push(redirectPath);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      this.$router.push('/oidc-callback-error');
    }
  }
}
